import { Injectable, signal } from '@angular/core';
import { BackendErrorMessage } from '../http/get-backend-error-message';

const DISCARD_WINDOW_MS = 2000;

@Injectable({ providedIn: 'root' })
export class ErrorModalService {
  private readonly _currentError = signal<BackendErrorMessage | null>(null);
  readonly currentError = this._currentError.asReadonly();

  private lastShownAt = 0;
  private triggerElement: WeakRef<HTMLElement> | null = null;

  show(message: BackendErrorMessage, trigger?: HTMLElement | null): void {
    const now = Date.now();
    if (this._currentError() !== null) {
      return;
    }
    if (now - this.lastShownAt < DISCARD_WINDOW_MS) {
      return;
    }
    this.triggerElement = trigger ? new WeakRef(trigger) : null;
    this.lastShownAt = now;
    this._currentError.set(message);

    const tracePart = message.traceId ? ` traceId=${message.traceId}` : '';
    // eslint-disable-next-line no-console
    console.error(`[ErrorModal] ${message.title}${tracePart} — ${message.detail}`);
  }

  dismiss(): void {
    this._currentError.set(null);
  }

  getTriggerElement(): HTMLElement | null {
    return this.triggerElement?.deref() ?? null;
  }
}
